module.exports = __webpack_public_path__ + "static/fonts/SanFranciscoDisplayBold.af146d8.eot";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/SanFranciscoDisplayBold.eot
// module id = cr+j
// module chunks = 1